import { render, staticRenderFns } from "./UserManagementTemplate.vue?vue&type=template&id=122ac339"
import script from "./UserManagementTemplate.vue?vue&type=script&lang=ts"
export * from "./UserManagementTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('122ac339')) {
      api.createRecord('122ac339', component.options)
    } else {
      api.reload('122ac339', component.options)
    }
    module.hot.accept("./UserManagementTemplate.vue?vue&type=template&id=122ac339", function () {
      api.rerender('122ac339', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/UserManagementTemplate/UserManagementTemplate.vue"
export default component.exports